import { isLocalHost } from '@/services/environment.js'

const LOCAL_ENDPOINT = 'http://api.jpujol.local:15000'
const QA_ENDPOINT = 'https://api-jpujol.cyangecko.com'
const PROD_ENDPOINT = 'https://api.jpujol.com'

// The API follows the hostname the front is served on (ADR-0061).
export default function () {
  const hostname = window.location.hostname

  if (isLocalHost(hostname)) return LOCAL_ENDPOINT
  if (/\.cyangecko\.com$/.test(hostname) && !/prod/.test(hostname)) return QA_ENDPOINT

  return PROD_ENDPOINT
}
